import { Injectable } from "@angular/core";
import { CommodityType } from "../interfaces/invoice-interfaces";
import { FilesInExtractionResponse } from "../interfaces/file-upload-interfaces";
import { FilesService } from "../api/files.service";
import { UserDataService } from "./user-data.service";
import { Observable, Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FileExtractionService {
    constructor(private filesService: FilesService, private userData: UserDataService) { }

    extractionCompleted$ = new Subject<void>();
    extractionCheckTimeoutId?: any;
    wasExtractionOngoing = false;
    pollingActive = false;
    readonly pollingIntervalMs = 20000;

    onExtractionCompleted(): Observable<void> {
        return this.extractionCompleted$.asObservable();
    }

    startCheckingExtractionStatus(type?: CommodityType.electricity | CommodityType.gas): void {
        if (this.pollingActive) {
            return;
        }

        this.pollingActive = true;
        this.checkExtractionStatus(type);
    }

    stopCheckingExtractionStatus(): void {
        if (this.extractionCheckTimeoutId) {
            clearTimeout(this.extractionCheckTimeoutId);
            this.extractionCheckTimeoutId = undefined;
        }
        this.pollingActive = false;
    }

    checkExtractionStatus(type?: CommodityType.electricity | CommodityType.gas): void {
        const companyId = this.userData.getUser()?.company?.id;
        
        if (!companyId) {
            console.warn('No company ID available');
            this.pollingActive = false;
            return;
        }

        let checkFileExtraction: Observable<FilesInExtractionResponse>;
        
        switch (type) {
            case CommodityType.electricity:
                checkFileExtraction = this.filesService.checkExtractionInProgressElectricity(companyId);
                break;
            case CommodityType.gas:
                checkFileExtraction = this.filesService.checkExtractionInProgressGas(companyId);
                break;
            default: 
                checkFileExtraction = this.filesService.checkExtractionInProgress(companyId);
        }

        checkFileExtraction.subscribe({
            next: (status: FilesInExtractionResponse) => {
                if (this.wasExtractionOngoing && !status.in_progress) {
                    this.extractionCompleted$.next();
                }
                
                this.wasExtractionOngoing = status.in_progress;
                
                if (this.pollingActive) {
                    this.extractionCheckTimeoutId = setTimeout(() => {
                        this.checkExtractionStatus(type);
                    }, this.pollingIntervalMs);
                }
            },
            error: (error) => {
                console.error('Error checking extraction status:', error);
                if (this.pollingActive) {
                    this.extractionCheckTimeoutId = setTimeout(() => {
                        this.checkExtractionStatus(type);
                    }, this.pollingIntervalMs);
                }
            }
        });
    }

    isExtractionOngoing(): boolean {
        return this.wasExtractionOngoing;
    }
}